import { Injectable } from '@angular/core';
import { supabase } from '../../core/supabase/supabase.client';

export interface DeliveryReturnCase {
  order_id: number; state: string; call_attempts: number; wait_until: string; server_time: string;
  started_at: string; review_requested_at: string | null; approved_by: string | null;
  at_store_at: string | null; received_at: string | null; distance_km: number; approval_note: string | null;
  payout_snapshot: { base_fare: number; per_km_rate: number; total_earning: number; bonus: number; surge_amount: number };
  expected_items: Array<{ variant_id: number; quantity: number }>;
}
@Injectable({ providedIn: 'root' })
export class DeliveryReturnService {
  async get(orderId: number): Promise<DeliveryReturnCase | null> {
    const { data, error } = await supabase.rpc('get_delivery_return_case', { p_order_id: orderId });
    if (error) throw error;
    return data as DeliveryReturnCase | null;
  }
  async receive(orderId: number, disposition: 'RESTOCK' | 'WASTAGE' | 'NO_STOCK_CHANGE', note: string, items: Array<{ variant_id: number; quantity: number }>): Promise<void> {
    const { data, error } = await supabase.rpc('admin_receive_unreachable_return', {
      p_order_id: orderId, p_disposition: disposition, p_note: note, p_received_items: items,
    });
    if (error) throw error;
    if (data?.success !== true) throw new Error('Return receipt was not confirmed');
  }
}
